







































































































































































































import IWarehouse from '@/store/models/IWarehouse';
import IListPhonePrefix from '@/store/models/IListPhonePrefix';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import WarehouseContactsSelector from '@/components/selectors/Warehouse/WarehouseContactsSelector.vue';
import IListCountries from '@/store/models/IListCountries';
import IWarehouseContacts from '@/store/models/IWarehouseContacts';
import Snackbar from '@/components/shared/Snackbar.vue';
import ICompany from '@/store/models/ICompany';
import IRolePermission from '@/store/models/IRolePermission';

@Component({
    components: {
        WarehouseContactsSelector,
        Snackbar
    }
})
export default class WarehouseSelector extends Vue {
    searchWarehouse: string = "";
    dialog: boolean = false;
    isValid: boolean = true;
    sortBy: string = 'name';
    sortDesc: boolean = false;
    headers: any = [
        { text: 'Name',
            align: 'start',
            value: 'name'
        },
        { text: 'Street', value: 'street' },
        { text: 'Number', value: 'number' },
        { text: 'City', value: 'city' },
        { text: 'ZipCode', value: 'zipCode' },
        { text: 'Country', value: 'countryName' },
        { text: 'Phone Number', value: 'phoneNumber' },
        { text: 'Actions', value: 'actions', sortable: false }
    ];
    editedIndex : number = -1;
    editedItem : IWarehouse = {
        id: "",
        name: "",
        street: "",
        number: "",
        city: "",
        zipCode: "",
        idListCountry: "",
        countryName: "",
        code: "",
        idListPhonePrefix: "",
        prefix: "",
        phoneNumber: "",
        idCompany: ""
    }
    defaultItem :IWarehouse = {
        id: "",
        name: "",
        street: "",
        number: "",
        city: "",
        zipCode: "",
        idListCountry: "",
        countryName: "",
        code: "",
        idListPhonePrefix: "",
        prefix: "",
        phoneNumber: "",
        idCompany: ""
    }

    @Prop({ type: Array, required: true })
    WarehouseList !: IWarehouse[];
    @Prop({ type: Array, required: true })
    ListPhonePrefix !: IListPhonePrefix[];
     @Prop({ type: Array, required: true })
    ListCountries !: IListCountries[];
    @Prop({ type: Array, required: true })
    WarehouseContactsList !: IWarehouseContacts[];
    @Prop({ type: Array, required: true })
    CompanyList !: ICompany[];
    @Prop()
    IdCompany !: string;
    @Prop({ type: Array, required: true })
    Permissions !: IRolePermission[];
    @Prop()
    value !: ICompany;

    selectedWarehouse : IWarehouse[] = [];
    selectedWarehouseContact : IWarehouseContacts[] = [];
    selectedPhonePrefix: any = null;
    selectedCompany: any = null;
    phonePrefixCountry : string[] = [];

    get ListPhonePrefixesSort () {
        return [...this.ListPhonePrefix].sort((a, b) => a.prefix.localeCompare(b.prefix));
    }

    get formTitle() { return this.editedIndex === -1 ? 'New Warehouse' : 'Edit Warehouse'; }

    @Watch('dialog')
    onDialogChanged(val: any) {
        val || this.close();
    }

    @Watch('value')
    updateSelection(newValue : IWarehouse | null) {
        if (!newValue || Object.keys(newValue).length === 0) {
            this.selectedWarehouse = [];
        } else {
            this.selectedWarehouse = [newValue];
            this.$emit('warehouseChanged', this.selectedWarehouse[0]);
        }
    }

    ResetWarehouse() {
        this.$emit('resetWarehouse');
    }

    editWarehouse (item: any, dbox = true) {
        if (this.selectedWarehouse.length > 0) {
            this.editedIndex = this.WarehouseList.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.selectedCompany = this.CompanyList.find(p => p.id === this.selectedWarehouse[0].idCompany);
            this.selectedPhonePrefix = this.ListPhonePrefix.find(p => p.id === this.editedItem.idListPhonePrefix);
            this.dialog = true;
        }
    }

    saveWarehouse (warehouse: IWarehouse) {
        if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
            this.setCountryPrefix();
            this.setSelectedCompany();
            this.setSelectedCountry();
            if (this.editedIndex > -1 || this.selectedWarehouse[0]) {
                this.close();
                this.$emit('editWarehouse', this.editedItem);
                Object.assign(this.WarehouseList[this.editedIndex], this.editedItem);
            } else {
                this.$emit('saveWarehouse', this.editedItem);
            }
        } else {
            this.$emit('showMessageWarning', 'All required fields must be filled out');
        }
    }

    deleteWarehouse (warehouse: IWarehouse) {
        if (this.selectedWarehouse.length > 0) {
            this.$emit('deleteWarehouse', warehouse);
            this.close();
        }
    }

    close() : void {
        this.dialog = false;
        this.$nextTick(() => {
            this.editedItem = Object.assign({}, this.defaultItem);
            this.editedIndex = -1;
        });
    }
    
    setSelectedCompany() {
        if (this.selectedCompany) {
            let company: any = this.CompanyList.find(c => c.name === this.selectedCompany.name);
            if (company) {
                this.editedItem.idCompany = company.id;
            }
        }
    }

    setSelectedCountry() {
        if (this.selectedPhonePrefix) {
            let country: IListCountries = this.ListCountries.find(p => p.countryName === this.selectedPhonePrefix.country)!;
            if (country) {
                this.editedItem.idListCountry = country.id;
                this.editedItem.code = country.code;
                this.editedItem.countryName = country.countryName;
            }
        }
    }

    setCountryPrefix() {
        if (this.selectedPhonePrefix) {
            let phonePrefix: IListPhonePrefix = this.ListPhonePrefix.find(p => p.country === this.selectedPhonePrefix.country)!;
            if (phonePrefix) {
                this.editedItem.idListPhonePrefix = phonePrefix.id;
                this.editedItem.prefix = phonePrefix.prefix;
            }
        }
    }

    select(item : IWarehouse) : void {
        let index : number = this.selectedWarehouse.findIndex(w => w.id === item.id);
        if (index === -1) {
            this.selectedWarehouse = [item];
            this.$emit('input', item);
        } else {
            let warehouse = this.selectedWarehouse.find(w => w.id === item.id);
            if (!warehouse) {
                this.selectedWarehouse = [];
                this.$emit('input', null);
            }
        }
    }

    saveWarehouseContact(item : any) : void {
        this.$emit('saveWarehouseContact', item);
    }

    editWarehouseContact(item : any) : void {
        this.$emit('editWarehouseContact', item);
    }
    
    deleteWarehouseContact(item : any) : void {
        this.$emit('deleteWarehouseContact', item);
    }
    
    showMessageInfo(message: string) {
        (this.$refs.snackbar as Snackbar).showInfo(message);
    }

    showMessageError(message: string) {
        (this.$refs.snackbar as Snackbar).showError(message);
    }
    
    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }
}
